import React from 'react';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';
import { useComprasPurchaseSite } from '../../contexts/ComprasPurchaseSiteContext';

const ComprasSiteFilterTabs = ({ siteView, onSiteViewChange, withoutCount }) => {
  const { comprasPurchaseSitesEnabled } = useModuleSettings();
  const { selectedPurchaseSite } = useComprasPurchaseSite();

  if (!comprasPurchaseSitesEnabled) return null;

  const siteLabel = selectedPurchaseSite
    ? `${selectedPurchaseSite.code ? `${selectedPurchaseSite.code} — ` : ''}${selectedPurchaseSite.name}`
    : 'Sede activa';

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <button
        type="button"
        onClick={() => onSiteViewChange('active')}
        className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${
          siteView === 'active'
            ? 'bg-teal-600 text-white border-teal-600'
            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
        }`}
      >
        {siteLabel}
      </button>
      <button
        type="button"
        onClick={() => onSiteViewChange('without')}
        className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${
          siteView === 'without'
            ? 'bg-amber-600 text-white border-amber-600'
            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
        }`}
      >
        Sin sede{withoutCount != null ? ` (${withoutCount})` : ''}
      </button>
    </div>
  );
};

export default ComprasSiteFilterTabs;
